// extracted by mini-css-extract-plugin
export default {"headerBlock":"InfoPage_headerBlock__3PZug","content":"InfoPage_content__cp2Zq","contentText":"InfoPage_contentText__8shdg","collapseBlock":"InfoPage_collapseBlock__E789I"};